import { useFormContext, useFormState, useWatch } from "react-hook-form";

import {
  ELEMENT_WRAPPER_MB,
  ElementWrapper,
  ErrorMessage,
  InputText,
  Label,
  createValidation,
  getErrorMessage,
} from "@up/form";

import type { TErrorMessageKey } from "@up/form";
export function CollegeCurrentSchoolCity({
  label = "Current School City",
}: {
  label?: string;
}) {
  const { register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  const KEY = "college-current-school-address-city";
  const VALIDATION = { presence: true };
  const ERRORS = errors[KEY];

  return (
    <ElementWrapper className={ELEMENT_WRAPPER_MB} hasErrors={!!ERRORS}>
      <Label htmlFor={KEY} required={true} text={label} />
      <InputText
        registerProps={register(KEY, createValidation(VALIDATION, formValues))}
      />
      <ErrorMessage
        text={
          ERRORS
            ? getErrorMessage(ERRORS.type as TErrorMessageKey, VALIDATION)
            : null
        }
      />
    </ElementWrapper>
  );
}
